export const PRODUCTS_SYNC_FEATURE_KEY = 'products-sync';
